import './CSS/MySkillsTitle.css';
function MySkillsTitle (props) {
    return (
      
      <article class="glass down">
         <hr class="new2"></hr>
       <h1 id="mySkillsText"> Skills </h1>
       </article>
        
    );
  }
  
  export default MySkillsTitle;
  